<template>
    <select id="country" name="country" class="form-control country-control" v-model="selectedCountry">
        <option value="">Please select country</option>
        <option v-for="(country, index) in this.Countries" :key="index" :value="country.ISO2">
            {{country.CountryName}}
        </option>
    </select>
</template>
<script>
    import axios from 'axios'
    import getEndPoint, { countriesAPI } from '../../constants/api.config';
    export default {
        name: "CountryDropdown",
        props: ["oncountryload"],
        data() {
            return {
                Countries: [
                    {
                        CountryID: "",
                        CountryName: "",
                        ISO2: ""
                    }
                ],
                selectedCountry: ""
            }
        },
        methods: {
            getCountries(data) {
                let c = [];
                data.forEach(element => {
                    c.push(
                        {
                            CountryID: element.countryID,
                            CountryName: element.countryName,
                            ISO2: element.isO2
                        }
                    );
                });

                return c;
            }
        },
        mounted() {
            let storage = localStorage.getItem("CountriesList");
            if (storage) {
                this.Countries = JSON.parse(storage);
                this.selectedCountry = this.Countries.find(c => c.CountryName == window.DEALER_LOCATION.address.country)?.ISO2 ?? this.Countries[0].ISO2;
                this.oncountryload(this.selectedCountry);
            }
            else {
                axios.get(getEndPoint(countriesAPI))
                    .then((response) => (
                        storage = this.getCountries(response.data),
                        this.Countries = this.getCountries(response.data),
                        localStorage.setItem('CountriesList', JSON.stringify(storage)),
                        this.selectedCountry = this.Countries.find(c => c.CountryName == window.DEALER_LOCATION.address.country)?.ISO2 ?? this.Countries[0].ISO2,
                        this.oncountryload(this.selectedCountry)
                    ))
                    .catch((error) => console.log(error));
            }
        }
    };
</script>
